import { DextDatePickerWUT } from '@wix/form-fields/viewer-wut';

export default DextDatePickerWUT;
